<template>
    <div>
        <b-table-simple responsive striped>
            <b-thead head-variant="dark">
                <b-tr>
                    <b-th>{{ 'guessed' | lang }}</b-th>
                    <b-th>{{ 'amount' | lang }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="({ guessed, amount }, index) in items" :key="index">
                    <b-td :variant="index % 2 ? 'success-light' : 'success'">{{ guessed }}</b-td>
                    <b-td>{{ amount }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <div>
            <span class="text-danger">*</span>
            <span>{{ 'rules.if_more_winners' | lang }}</span>
        </div>
    </div>
</template>

<script>
import { head } from 'lodash';
import lang from '@tv/filters/lang';
import currency from '@tv/filters/currency';

export default {
    props: ['game'],

    data() {
        return {
            fields: [
                {
                    key: 'guessed',
                    label: lang('guessed'),
                },
                {
                    key: 'amount',
                    label: lang('amount'),
                },
            ],
        };
    },

    computed: {
        guessNumbers() {
            const values = Object.values(this.game.guesses_values)
                .map(item => item.guessed);
            
            return [ ...new Set(values) ].reverse();
        },

        items() {
            const items = [];

            const amount  = head(Object.values(this.game.amounts)).amount;

            for (const guessNumber of this.guessNumbers) {
                for (const guessValue of Object.values(this.game.guesses_values)) {
                    if (guessNumber == guessValue.guessed) {
                        const guessed = `${guessNumber} ${lang('of')} 7`;
                        if (guessValue.sharing) {
                            const pool = head(Object.values(this.game.pools));
                            items.push({ guessed, amount: `${pool.name} *` });
                        } else {
                            items.push({ guessed, amount: currency(guessValue.multiplier * amount) });
                        }
                        break;
                    }
                }
            }

            return items;
        },
    },
}
</script>